(function(window, document, $, undefined){

  return false;
  
  $('.mobile-menu-trigger').click(function(e) {
    e.preventDefault();
    $('.mega-menu-navigation').fadeIn();
  });

  $('.close-mobile-menu').click(function(e) {
    e.preventDefault();
    $('.mega-menu-navigation').fadeOut();
  });

  // $('.mega-menu > ul').on('click', '> li', function(e) {
  //   e.preventDefault();
  //   // console.log('dfsf');
  //   var megamenu = $(this).find('> ul');
  //   if(megamenu.css('opacity')=='1'){
  //     megamenu.css({opacity:0,visibility:'hidden'});
  //   } else {
  //     megamenu.css({opacity:1,visibility:'visible'});
  //   }
  // }); 


  // return false;


  // //------------------------------------------- js version -----------------------------------------------------

  // //remove no-js class so css hover is disabled.
  // $( ".mega-menu > ul > li" ).removeClass('no-js');

  // var speed = 0.2;
  // var easing = Power3.easeOut;
  // easing = Power4.easeOut;

  // var hoverIntent;


  // $('.mega-menu > ul').on('mouseenter', '> li', function(e) {
  //   e.preventDefault();
  //   console.log('asd');
  //   var megamenu = $(this).find('> ul');
  //   megamenu.css('height','auto');
  //   var megamenuHeight = megamenu.outerHeight();
  //   var content = $(this).find('> ul > li');
  //   // megamenu.css('display','none');
  //   // USE CLASS INSTEAD ADD CLASS WITH JS, THEN THAT HIDES

  //   TweenMax.set(megamenu,{height:0,paddingTop:0,paddingBottom:0});
  //   TweenMax.set(content,{autoAlpha:0});
  //   // TweenMax.set(megamenu,{css:{display:'block'}});
  //   TweenMax.to(megamenu,0.3,{height:megamenuHeight,paddingTop:20,paddingBottom:30,ease:easing,onComplete:function(){
  //     megamenu.css('height','auto');
  //   }});
  //   TweenMax.to(content,0.3,{autoAlpha:1,delay:0.2});
  // });  



  // $( ".mega-menu > ul > li" ).hover(
  //   function() {
  //     // $( this ).append( $( "<span> ***</span>" ) );
  //   }, function() {
  //     // $( this ).find( "span:last" ).remove();
  //   }
  // );




})(window, document, jQuery);
